const Maintenance = () => {
  return (
    <div className="maintenance-wrapper">
      <h1>En mantenimiento, volvemos en unos minutos</h1>
    </div>
  );
};

export default Maintenance;
